import { FC } from "react";

import { Stack } from "@mui/material";

import { PeerToPeerDonateCampaignAction } from "./PeerToPeerDonateCampaignAction";
import { PeerToPeerPrimaryCampaignFundraiseCampaignAction } from "./PeerToPeerPrimaryCampaignFundraiseCampaignAction";
import { PeerToPeerRegisterCampaignAction } from "./PeerToPeerRegisterCampaignAction";

import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
import { FormTypography } from "@/forms-design-system/FormTypography";

export type PeerToPeerPrimaryCampaignActionsProps = {
  allowTeamCreation: boolean;
  allowJoinTeam: boolean;
  allowFundraiserCreation: boolean;
  hasTeamCampaigns: boolean;
  hasIndividualCampaigns: boolean;
  hasRegistration: boolean;
  onDonateButtonClick?: () => void;
  onFundraiseButtonClick?: () => void;
  onRegisterButtonClick?: () => void;
  shouldHideFundraise?: boolean;
};

export const PeerToPeerPrimaryCampaignActions: FC<PeerToPeerPrimaryCampaignActionsProps> = ({
  allowTeamCreation,
  allowJoinTeam,
  allowFundraiserCreation,
  hasTeamCampaigns,
  hasIndividualCampaigns,
  hasRegistration,
  onFundraiseButtonClick,
  onDonateButtonClick,
  onRegisterButtonClick,
  shouldHideFundraise,
}) => {
  const { t } = useTranslate();
  const isGhostPreview = useIsGhostPreview("PeerToPeerPrimaryCampaignActions");

  const showFundraise = !shouldHideFundraise && (allowTeamCreation || allowFundraiserCreation || allowJoinTeam);

  return (
    <Stack
      gap={2}
      id="p2p-primary-campaign-actions"
      sx={{
        ...(isGhostPreview && {
          opacity: GHOST_PREVIEW_OPACITY,
        }),
      }}
    >
      <FormTypography variant="h6" vibe="intense">
        {t("donationForm", "peerToPeer.howDoYouWantToContribute")}
      </FormTypography>
      <PeerToPeerDonateCampaignAction
        canDonateToTeamCampaign={hasTeamCampaigns}
        canDonateToIndividualCampaign={hasIndividualCampaigns}
        onClick={onDonateButtonClick}
      />
      {hasRegistration && <PeerToPeerRegisterCampaignAction onClick={onRegisterButtonClick} />}
      {showFundraise && (
        <PeerToPeerPrimaryCampaignFundraiseCampaignAction
          canCreateTeamCampaigns={allowTeamCreation}
          canJoinTeamCampaigns={allowJoinTeam}
          canCreateIndividualCampaigns={allowFundraiserCreation}
          hasRegistration={hasRegistration}
          onClick={onFundraiseButtonClick}
        />
      )}
    </Stack>
  );
};
